import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { ButtonSubmit, Form } from '@anytag/shared-atoms';
import { SelectorField, TextField } from '@anytag/shared-molecules';
import { useAllCountryOptions, useAllPackageCompanyOptions } from '@anytag/shared-hooks';
import { PackageFormValues, PackageFormKeys } from './types';

interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const { allCountryOptions } = useAllCountryOptions();
  const { isAdminStaff, isPartner, isTalentAgency } = useUserRoles();
  const {
    getValues,
    formState: { isSubmitting }
  } = useFormContext<PackageFormValues>();
  const values = getValues();
  const { allPackageCompanyOptions } = useAllPackageCompanyOptions({
    skip: !(isAdminStaff || (!!values.id && (isPartner || isTalentAgency)))
  });

  return (
    <>
      <Form.Body className="form-container">
        <Form.SectionTitle label={values.name || t('New Package')} />

        <TextField<PackageFormKeys>
          name="name"
          title={t('TextForm.Package Name')}
          placeholder={t<string>('package name')}
          required
        />

        <Form.Fields itemsPerRow={2}>
          <SelectorField<PackageFormKeys>
            name="countryId"
            title={t('Selector.Country')}
            options={allCountryOptions}
            required
          />

          {allPackageCompanyOptions.length ? (
            <SelectorField<PackageFormKeys>
              title={t('Selector.Company')}
              name="companies"
              options={allPackageCompanyOptions}
              disabled={isPartner || isTalentAgency}
              multiple
            />
          ) : null}
        </Form.Fields>
      </Form.Body>

      <Form.Footer>
        <ButtonSubmit onClick={onSubmit} loading={isSubmitting} disabled={isSubmitting} title={t('Button.Save')} />
      </Form.Footer>
    </>
  );
};
